export default "__VITE_ASSET__01ef1709__"